// ORBIT — one-question spotlight carousel. A single centered card shows one
// Q&A at a time; round prev/next buttons and a tabular "1 / N" counter move
// through the rest.
function spotHtml(ctx, it, i, total) {
    return `<div class="fq-spot" data-idx="${it.idx}"${i > 0 ? ' hidden' : ''} role="group" aria-roledescription="slide" aria-label="${ctx.t('position', { current: i + 1, total })}">
    <h3 class="fq-q">${it.q}</h3>
    <div class="fq-a">${it.aHtml}</div>
  </div>`;
}
const orbit = {
    id: 'orbit',
    name: 'Orbit',
    tag: 'Spotlight carousel',
    styleTag: 'Focused',
    description: 'One question in the spotlight, arrows to move through the rest. Great in tight spaces \u2014 sidebars, checkout pages, or anywhere a full list is too much.',
    layout: 'cards',
    defaultAccent: '#4a6cf7',
    darkDefault: false,
    catSupport: 'none',
    features: ['carousel'],
    render(ctx) {
        const total = ctx.items.length;
        const spots = ctx.items.map((it, i) => spotHtml(ctx, it, i, total)).join('\n');
        const html = `<div class="fq-wrap">
  <h2 class="fq-title">${ctx.title}</h2>
  ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
${spots}
  <div class="fq-nav">
    <button class="fq-prev" type="button" aria-label="${ctx.t('previous')}">${ctx.svg.arrowLeft}</button>
    <span class="fq-count">1 / ${total}</span>
    <button class="fq-next" type="button" aria-label="${ctx.t('next')}">${ctx.svg.arrowRight}</button>
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:600px;margin:0 auto;text-align:center}
.FQM .fq-title{margin:0 0 6px;font-family:${ctx.v.head};font-size:32px;font-weight:650;line-height:1.12;letter-spacing:-0.015em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0 0 26px;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-spot{min-height:200px;display:flex;flex-direction:column;justify-content:center;gap:12px;padding:34px 34px 30px;border-radius:${ctx.v.radiusWrap};background:${ctx.v.card};border:1px solid ${ctx.v.border};box-shadow:0 12px 32px rgba(15,30,60,0.07)}
.FQM .fq-spot[hidden]{display:none}
.FQM .fq-q{margin:0;font-family:${ctx.v.head};font-size:21px;font-weight:650;line-height:1.35;color:${ctx.v.ink}}
.FQM .fq-a{font-size:15.5px;line-height:1.65;color:${ctx.v.sub}}
.FQM .fq-nav{display:flex;align-items:center;justify-content:center;gap:16px;margin-top:20px}
.FQM .fq-prev,.FQM .fq-next{display:grid;place-items:center;width:40px;height:40px;border-radius:999px}
.FQM .fq-prev{border:1px solid ${ctx.v.border};background:${ctx.v.card};color:${ctx.v.ink}}
.FQM .fq-next{background:${ctx.v.accent};color:#ffffff}
.FQM .fq-prev .fq-svg,.FQM .fq-next .fq-svg{width:13px;height:13px}
.FQM .fq-count{min-width:52px;font-size:13px;color:${ctx.v.sub};font-variant-numeric:tabular-nums}
`;
        return { html, css };
    },
};
export default orbit;
